var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "CreatePassThroughInvoice",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              resourceTitle: _vm._f("pgettext")(
                "Pass-through Invoice",
                "Invoice"
              ),
              resourceKey: _vm.documentTitle
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              _vm.loaded
                ? _c(
                    "ItpForm",
                    {
                      attrs: {
                        id: _vm.formId,
                        name: "invoice",
                        autofocus: "first"
                      },
                      on: {
                        submit: function($event) {
                          return _vm.evh_1040167445267876_submit($event, {})
                        }
                      }
                    },
                    [
                      _c(
                        "ItpFormGroup",
                        {
                          attrs: {
                            name: "client",
                            label: _vm._f("pgettext")("Client", "Invoice"),
                            labelAlign: _vm.labelAlign,
                            labelColsMd: "3",
                            contentColsMd: "9",
                            helpTooltip: _vm._f("pgettext")(
                              "Specify the client to be re-invoiced.",
                              "CreatePassThroughInvoice|Tooltip"
                            ),
                            required: ""
                          }
                        },
                        [
                          _c("ItpFormSelect2", {
                            attrs: {
                              name: "client",
                              dataSource: _vm.b_7789867021953041_dataSource,
                              valueField: "id",
                              textField: "name",
                              "bind-object": "",
                              optionTemplate:
                                "<UcSuggestCompanyOption :option=option></UcSuggestCompanyOption>",
                              "use-option-template-for-selected-option": "",
                              required: ""
                            },
                            model: {
                              value: _vm.item.client,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "client", $$v)
                              },
                              expression: "item.client"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "ItpFormGroup",
                        {
                          attrs: {
                            name: "ratio",
                            label: _vm._f("pgettext")(
                              "Multiplier",
                              "CreatePassThroughInvoice"
                            ),
                            labelAlign: _vm.labelAlign,
                            labelColsMd: "3",
                            contentColsMd: "3",
                            helpTooltip: _vm._f("pgettext")(
                              "Line items will be generated with the given multiplier.",
                              "CreatePassThroughInvoice|Tooltip"
                            ),
                            required: ""
                          }
                        },
                        [
                          _c("ItpFormInput", {
                            attrs: { type: "number", name: "ratio" },
                            model: {
                              value: _vm.item.ratio,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "ratio", $$v)
                              },
                              expression: "item.ratio"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _c("ItpButton", {
                attrs: {
                  form: _vm.forms.invoice,
                  text: _vm._f("pgettext")(
                    "Create invoice",
                    "CreateInvoice|Submit"
                  ),
                  type: "submit",
                  variant: "primary",
                  spinning: _vm.actions.submit && _vm.actions.submit.isRunning
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("gettext")("Close"),
                  variant: "default",
                  disabled: _vm.actions.submit.isRunning
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_1419464017721962_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }